import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Rescue Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details:</p>
            <ul>
                <li>
                    $8.7 billion in support for struggling employers; individual
                    business can access up to $150,000 in support.
                </li>
                <li>
                    $585 per full-time employee and $350 per part time employee.
                </li>
                <li>Tax relief</li>
                <li>Wage subsidy and leave payment</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: "Coronavirus financial package: Government's $12b support plan for businesses, beneficiaries",
            url: 'https://www.nzherald.co.nz/nz/news/article.cfm?c_id=1&objectid=12317279',
        },
        {
            title: 'Application for Tax Relief',
            url: 'https://www.ird.govt.nz/covid-19-novel-coronavirus/tax-relief/tax-relief-for-businesses',
        },
        {
            title: 'Wage Subsidy and Leave Payment Application Information',
            url: 'https://workandincome.govt.nz/products/a-z-benefits/covid-19-support.html',
        },
        {
            title: 'Financial Information Support - employers, individuals, students',
            url: 'https://workandincome.govt.nz/eligibility/emergencies/2020/coronavirus.html',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'New Zealand',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>New Zealand has announced a 12.1 billion rescue package.</p>
    ),
    sections: [PACKAGE_SECTION],
};

const NewZealandInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default NewZealandInfo;
